const ExperienceExtraTabButton = ({
  tab,
  label,
  currentTab,
  setCurrentTab,
}) => {
  return (
    <div
      className={[
        'flex items-center gap-2 mt-2 mr-1 py-2 px-3 text-base font-medium rounded-xl border hover:border-gray-500 border-gray-300 transition ease-in bg-white',
        currentTab === tab
          ? 'bg-gradient-to-b from-k-gd1 to-k-gd2 text-white'
          : 'text-gray-500',
      ].join(' ')}
      id={tab}
      onClick={() => setCurrentTab(tab)}
      data-testid={`tab-${tab?.toLowerCase()}-extras`}
    >
      {label}
    </div>
  );
};
export default ExperienceExtraTabButton;
